module.exports = __webpack_public_path__ + "static/assets/a6a10707fe9a131390ccb9d9d7449734.png";